import React from 'react';
import { string, oneOfType, array, object } from 'prop-types';

const SvgIcon = ({
  className,
  viewBox,
  width,
  height,
  children,
  isFocused,
  ...otherProps
}) => {
  return (
    <svg
      className={className}
      focusable="false"
      viewBox={viewBox || `0 0 ${width} ${height}`}
      width={width}
      height={height}
      aria-hidden
      {...otherProps}
    >
      {children}
    </svg>
  );
};

SvgIcon.propTypes = {
  viewBox: string,
  // width: number,
  // height: number,
  children: oneOfType([array, object]).isRequired,
  className: string,
};

export default SvgIcon;
